"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AbstractMergeDateTimeRefiner_1 = __importDefault(require("../../../common/refiners/AbstractMergeDateTimeRefiner"));
class ELMergeDateTimeRefiner extends AbstractMergeDateTimeRefiner_1.default {
    patternBetween() {
        return new RegExp("^\\s*(Τ|(?:στη|στις|τον|την|το)|μετ[άα]\s?(?:τις|τη|το)?|πριν\s?(?:τις|τη|το)?|,|-)?\\s*$");
    }
}
exports.default = ELMergeDateTimeRefiner;
